import { BooleanInput } from '@angular/cdk/coercion';
import { Directive, EventEmitter } from '@angular/core';
import { AbstractControlDirective, NgControl } from '@angular/forms';
import { Observable } from 'rxjs';

@Directive()
export abstract class FormFieldControl<T> {
  /** The value of the control. */
  value: T | null;

  /**
   * Stream that emits whenever the state of the control changes
   * to notify the form field that it needs to run change detection.
   */
  readonly stateChanges: Observable<void>;

  /** Gets the NgControl for this control. */
  readonly ngControl: NgControl | AbstractControlDirective | null;

  /** Whether the control is disabled. */
  readonly disabled: BooleanInput;

  /** Whether the control is in an error state. */
  readonly hasError: boolean;

  readonly valueChange: EventEmitter<T>;

  readonly shouldPlaceholderFloat?: boolean;

  readonly loading?: BooleanInput;

  readonly focused?: boolean;

  updateErrorState?: () => void;
}
